<template>
    <div class="footers flex wrap center vcenter">
        <div class="row">
            <div class="body flex wrap space">
                <div class="c1 flex start">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d205.17319434019447!2d50.88068157915161!3d34.63522409303433!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzTCsDM4JzA2LjciTiA1MMKwNTInNTAuMiJF!5e0!3m2!1sen!2s!4v1715942593728!5m2!1sen!2s"
                        height="169" style="border:0;" allowfullscreen="" title="موقعیت مکانی آتیاکراد"
                        referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
                <div class="c2">
                    <h3>اطلاعات تماس</h3>
                    <p>آدرس: قم، خیابان معلم، مجتمع ناشران، واحد 531</p>
                    <p>کد پستی: 3715699685</p>
                    <p>مرکز تماس: 91004810-025</p>
                    <p>نمابر: 91004810-025 داخلی 9</p>
                    <p>پست الکترونیکی: info@atiyehiraniancf.com</p>
                </div>
                <div class="c3">
                    <h3>پیوند های مرتبط</h3>
                    <ul>
                        <li><a href="https://www.ifb.ir/" target="_blank">فرابورس</a></li>
                        <li><a href="https://www.seo.ir/" target="_blank">سازمان بورس</a></li>
                        <li><a href="https://www.cbi.ir/" target="_blank">بانک مرکزی</a></li>
                        <li><a href="https://daneshbonyan.isti.ir/%D8%B5%D9%86%D8%AF%D9%88%D9%82-%D9%86%D9%88%D8%A2%D9%88%D8%B1%DB%8C-%D9%88-%D8%B4%DA%A9%D9%88%D9%81%D8%A7%DB%8C%DB%8C"
                                target="_blank">صندوق نوآوری و شکوفایی</a></li>
                        <li><a href="https://www.inif.ir/" target="_blank">صندوق نوآوری و شکوفایی ریاست جمهوری</a></li>
                    </ul>
                </div>
                <div class="c4 flex center vcenter">
                    <div class="trusted flex wrap center vcenter">
                        <div class="flex vcenter">
                            <a href="/files/license.pdf" target="_blank">
                                <img v-lazy="'/images/faraburs.webp'" alt="آتیاکراد - فرابورس"
                                    title="آتیاکراد - فرابورس" loading="lazy" />
                            </a>
                        </div>
                        <div class="flex vcenter">
                            <a referrerpolicy="origin" target="_blank"
                                href="https://trustseal.enamad.ir/?id=505426&Code=ggikIv9ZQHKRpwCa93ngqsyVu88qJ41e"
                                rel="noopener">
                                <img referrerpolicy="origin"
                                    v-lazy="'/images/enamad.webp?id=397664&Code=gM6tvxmrUxWwipOe4S3RrjuUujhtXPZj'"
                                    alt="آتیاکراد - نماد اعتماد الکترونیکی" title="آتیاکراد - نماد اعتماد الکترونیکی"
                                    style="cursor:pointer" code="ggikIv9ZQHKRpwCa93ngqsyVu88qJ41e" loading="lazy">
                            </a>
                        </div>
                        <div class="flex vcenter">
                            <img referrerpolicy="origin" id="rgvjfukzoeukfukzapfunbqe" style="cursor:pointer"
                                onclick='window.open("https://logo.samandehi.ir/Verify.aspx?id=368652&p=xlaogvkamcsigvkadshwuiwk", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")'
                                v-lazy="'/images/samandehi.webp?id=368652&p=qftiwlbqaqgwwlbqujynodrf'"
                                alt="آتیاکراد - ساماندهی" title="آتیاکراد - ساماندهی" loading="lazy" />
                        </div>
                        <div class="flex vcenter">
                            <a href="https://daneshbonyan.isti.ir/" target="_blank">
                                <img v-lazy="'/images/bonyan.webp'" alt="آتیاکراد - دانش بنیان"
                                    title="آتیاکراد - دانش بنیان" loading="lazy" />
                            </a>
                        </div>
                        <div class="flex vcenter">
                            <a href="https://www.irfintech.com/" target="_blank">
                                <img v-lazy="'/images/fintech.webp'" alt="آتیاکراد - فاینتک" title="آتیاکراد - فاینتک"
                                    loading="lazy" />
                            </a>
                        </div>
                        <div class="flex vcenter">
                            <a referrerpolicy="origin"
                                href="https://tehran.irannsr.org/fa/trade_unit/2512270/swd_id/104366/%D8%A7%D8%B9%D8%B6%D8%A7%DB%8C-%D8%AD%D9%82%D9%88%D9%82%DB%8C-%D8%A8%D8%A7%D8%B1%D9%85%D8%A7%D9%86-%D8%A2%DA%98%D9%86%D8%AF-%D9%82%D8%B1%D9%86.html"
                                target="_blank">
                                <img v-lazy="'/images/nsr.webp'" alt="آتیاکراد - نظام صنفی رایانه ای"
                                    title="آتیاکراد - نظام صنفی رایانه ای" loading="lazy" />
                            </a>
                        </div>
                        <div class="flex vcenter">
                            <a referrerpolicy="origin" href="https://eanjoman.ir/member/IbCgQu1D8SiqpCfuI4Ru8WRDg"
                                target="_blank">
                                <img v-lazy="'/images/anjoman_1.webp'"
                                    alt="آتیاکراد - انجمن صنفی کارفرمایی فروشگاه های اینترنتی شهر تهران(کسب و کار های اینترنتی)"
                                    title="آتیاکراد - انجمن صنفی کارفرمایی فروشگاه های اینترنتی شهر تهران(کسب و کار های اینترنتی)"
                                    loading="lazy">
                            </a>
                        </div>
                        <div class="flex vcenter">
                            <a href="/" target="_blank">
                                <img v-lazy="'/images/anjoman_2.webp'" alt="آتیاکراد - اتحادیه کسب و کارهای مجازی"
                                    title="آتیاکراد - اتحادیه کسب و کارهای مجازی" loading="lazy" />
                            </a>
                        </div>
                        <div class="flex vcenter">
                            <a href="/" target="_blank">
                                <img v-lazy="'/images/tejarat.webp'"
                                    alt="آتیاکراد - انجمن انجمن علمی تجارت الکترونیکی ایران"
                                    title="آتیاکراد - انجمن انجمن علمی تجارت الکترونیکی ایران" loading="lazy" />
                            </a>
                        </div>
                        <div class="flex vcenter">
                            <a href="/files/vc.pdf" target="_blank">
                                <img v-lazy="'/images/vc.webp'" alt="آتیاکراد - انجمن سرمایه‌گذاری خطرپذیر "
                                    title="آتیاکراد - انجمن سرمایه‌گذاری خطرپذیر" loading="lazy" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer flex wrap center vcenter">
                <hr>
                <p>تمامی حقوق مادی و معنوی برای آتیه ایرانیان محفوظ است.</p>
                <div class="social">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Footer'
}
</script>

<style src="../assets/css/components/footer.css"></style>